
import { supabase } from '@/integrations/supabase/client';

// Clean up authentication state to prevent issues
export const cleanupAuthState = () => {
  // Remove standard auth tokens
  localStorage.removeItem('supabase.auth.token');
  // Remove all Supabase auth keys from localStorage
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
      localStorage.removeItem(key);
    }
  });
  // Remove from sessionStorage if in use
  Object.keys(sessionStorage || {}).forEach((key) => {
    if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
      sessionStorage.removeItem(key);
    }
  });
};

// MFA enrollment functions
export const enrollMFA = async () => {
  try {
    const { data, error } = await supabase.auth.mfa.enroll({
      factorType: 'totp'
    });
    
    if (error) throw error;
    return { 
      factorId: data.id,
      qrCode: data.totp.qr_code,
      secret: data.totp.secret 
    };
  } catch (error) {
    console.error('Error enrolling in MFA:', error);
    throw error;
  }
};

// Verify MFA during setup
export const verifyMFA = async (factorId: string, code: string) => {
  try {
    const { data, error } = await supabase.auth.mfa.challenge({ 
      factorId 
    });
    
    if (error) throw error;
    
    const challengeId = data.id;
    
    const { data: verifyData, error: verifyError } = await supabase.auth.mfa.verify({ 
      factorId,
      challengeId,
      code 
    });
    
    if (verifyError) throw verifyError;
    
    return { success: true };
  } catch (error) {
    console.error('Error verifying MFA code:', error);
    throw error;
  }
};

// Check if user has MFA enabled
export const getMFAFactors = async () => {
  try {
    const { data, error } = await supabase.auth.mfa.listFactors();
    
    if (error) throw error;
    
    return {
      factors: data.all,
      totpEnabled: data.totp.length > 0
    };
  } catch (error) {
    console.error('Error getting MFA factors:', error);
    return { factors: [], totpEnabled: false };
  }
};

// Unenroll from MFA
export const unenrollMFA = async (factorId: string) => {
  try {
    const { error } = await supabase.auth.mfa.unenroll({ factorId });
    
    if (error) throw error;
    
    return { success: true };
  } catch (error) {
    console.error('Error unenrolling from MFA:', error);
    throw error;
  }
};
